import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import pushAnalyticsEvent from 'common/utils/pushAnalyticsEvent';
import HfReactHelper from 'js/sign-components/common/hf-react-helper';
import SimpleGrayLayout from '../../../common/components/simple-gray-layout';
import EmailLink from '../../../common/components/email-link';

const messages = defineMessages({
  emailSubject: {
    id: '',
    description: 'Subject for an email to support about email confirmation',
    defaultMessage: 'Email Confirmation',
  },
});

class ConfirmRequiredPage extends React.Component {
  static propTypes = {
    siteCode: PropTypes.string.isRequired,
    intl: PropTypes.object.isRequired,
  };

  componentDidMount() {
    pushAnalyticsEvent({
      category: 'signup',
      action: 'check-email - hw',
      label: 'create an account',
    });
  }

  render() {
    const site = HfReactHelper.HfSites.getSite(this.props.siteCode);

    return (
      <SimpleGrayLayout siteCode={this.props.siteCode}>
        <h2>
          <FormattedMessage
            id=""
            description="Heading asking the user to check for a confirmation email"
            defaultMessage="Check your inbox"
          />
        </h2>
        <p>
          <FormattedMessage
            id=""
            description="Message confirming that password setup instructions were sent by email"
            defaultMessage="If that is a valid address, we have sent an email to it to set your password."
          />
        </p>
        <hr />
        <p>
          <FormattedMessage
            id=""
            description="Message directing the user to contact support if email confirmation fails"
            defaultMessage="If you're still experiencing difficulties, please contact us at {emailLink}."
            values={{
              emailLink: (
                <EmailLink
                  email={HfReactHelper.HfConstants.supportEmail[site]}
                  emailSubject={this.props.intl.formatMessage(
                    messages.emailSubject,
                  )}
                />
              ),
            }}
          />
        </p>
      </SimpleGrayLayout>
    );
  }
}

export default injectIntl(ConfirmRequiredPage);
